// eslint-disable-next-line @typescript-eslint/no-empty-function
export const NOOP = (): void => {};
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const ASYNC_NOOP = async (): Promise<void | never> => {};
